import { Module } from 'vuex';
import VehicleStatus from '@/dossier/constants/VehicleStatus';
import WorkStatus from '@/dossier/constants/WorkStatus';
import { RootState } from '@/general/store/states';
import { enumValues } from '@/shared/utils/typescript';
import { WorkshopPlanningUserSettings } from '../models/WorkshopPlanningUserSettings';

const DEFAULT_STATE: WorkshopPlanningUserSettings = {
  showWorkOrderContent: false,
  ignoreEventLock: false,
  showContacts: false,
  hideUnavailableMechanics: false,
  includedVehicleStatuses: enumValues(VehicleStatus),
  includedWorkStatuses: enumValues(WorkStatus),
};

const STORAGE_KEY = 'workshop_planner_user_settings_v3';

// cleanup legacy entries
localStorage.removeItem('workshop_planner_user_settings');

function loadState(): WorkshopPlanningUserSettings {
  const storedState = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  return { ...DEFAULT_STATE, ...storedState };
}

function saveState(state: WorkshopPlanningUserSettings): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

const module: Module<WorkshopPlanningUserSettings, RootState> = {
  namespaced: true,

  state: loadState(),

  mutations: {
    save(state, newState: WorkshopPlanningUserSettings): void {
      Object.assign(state, newState);
      saveState(newState);
    },
  },
};

export default module;
